import axios from 'axios';

const client = axios.create({ baseURL: '/trial-api', timeout: 20000 });
export async function trialRequest(path, data) {
  try {
    const response = data === undefined
      ? await client.get(path)
      : await client.post(path, data);
    if (!response.data || response.data.code !== 0) {
      throw new Error((response.data && response.data.msg) || '服务暂不可用，请稍后重试');
    }
    return response.data.data;
  } catch (error) {
    const message = error.response && error.response.data && error.response.data.msg;
    throw new Error(message || (error.code === 'ECONNABORTED'
      ? '响应超时，请保留当前信息并重试，我们会核对重复申请。'
      : error.message || '网络连接失败，请稍后重试'));
  }
}
export function newRequestKey() {
  const bytes = new Uint8Array(20);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}
